module.exports = __webpack_public_path__ + "static/media/de.6e41aa3c.svg";